import { render, staticRenderFns } from "./vRepContabilidad.vue?vue&type=template&id=6c4e1924&scoped=true&"
import script from "./vRepContabilidad.vue?vue&type=script&lang=js&"
export * from "./vRepContabilidad.vue?vue&type=script&lang=js&"
import style0 from "./vRepContabilidad.vue?vue&type=style&index=0&id=6c4e1924&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4e1924",
  null
  
)

export default component.exports